/* 
Common code for each of the provider task dialogs.
*/
import * as action from "@/store/levy-collection-providers/action-types";
import lookupMixins from "@/mixins/lookup.mixins";
import taskMixins from "@/mixins/task.mixins";
import ruleMixins from "@/mixins/rule.mixins";

export default {
  mixins: [lookupMixins, taskMixins, ruleMixins],
  model: {
    prop: "show",
    event: "update:show"
  },
  props: {
    show: {
      type: Boolean,
      default: false
    },
    levyCollectionId: {
      type: Number,
      default: null
    },
    providerId: {
      type: Number,
      default: null
    },
    task: {
      type: Object,
      default: null
    }
  },
  data() {
    return {
      explanation: null,
      due: null
    };
  },
  computed: {
    state() {
      return this.$store.state.levyCollectionProviders.task;
    },
    runAction() {
      if (this.explanation) {
        return action.TASK_RUN_WITH_EXPLANATION;
      } else if (this.due) {
        return action.TASK_RUN_WITH_DUE_DATE;
      } else {
        return action.TASK_RUN;
      }
    }
  },
  methods: {
    async run() {
      const successful = await this.$store.dispatch(this.runAction, {
        levyCollectionId: this.levyCollectionId,
        providerId: this.providerId,
        type: this.task.type,
        explanation: this.explanation,
        due: this.due
      });
      if (successful) {
        this.hide();
      }
    },
    hide() {
      this.$emit("update:show", false);
    }
  }
};
